import React from 'react';
import { observer } from 'mobx-react';

import { List } from 'antd';
import QueueAnim from 'rc-queue-anim';

const data = [
  {
    title: 'BASTIA 49',
    description: 'Milano',
    link: '#',
    key: '1',
  },
  {
    title: 'BATTISTI 15',
    description: 'Milano',
    link: '#',
    key: '2',
  },
  {
    title: 'BIXIO 29',
    description: 'Milano',
    link: '#',
    key: '3',
  },
  {
    title: 'BRAMANTE 65',
    description: 'Milano',
    link: '#',
    key: '4',
  },
];

@observer
class SearchPanel extends React.Component {
	render() {
		return (
		<div className="search-side">
			<div className="search-results">
     
				 <List
					itemLayout="horizontal"
					dataSource={data}
					renderItem={ item => (
            
						<a href={item.link}>
							<List.Item key={item.key}>
								<List.Item.Meta title={item.title} description={item.description} />
							</List.Item>
						</a>
            
					)}
				  />
          
			</div>
		</div>
		);
	}
}
export { SearchPanel };
